import React, { useState } from "react";
import bs58 from "bs58";

export default function PendingHandshakesView({ onBack }) {
  const [threshold, setThreshold] = useState(0.01); // default spam fee threshold
  const [pending, setPending] = useState([
    {
      viewKey: new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
      message: "Hey! Let's chat securely.",
      fee: 0.02,
    },
    {
      viewKey: new Uint8Array([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
      message: "Looking forward to talking.",
      fee: 0.005,
    },
  ]);

  const handleApprove = (viewKey) => {
    setPending((prev) =>
      prev.filter((p) => bs58.encode(p.viewKey) !== bs58.encode(viewKey))
    );
  };

  const handleReject = (viewKey) => {
    setPending((prev) =>
      prev.filter((p) => bs58.encode(p.viewKey) !== bs58.encode(viewKey))
    );
  };

  const filteredPending = pending.filter((p) => p.fee >= threshold);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: "#000",
        color: "#fff",
      }}
    >
      {/* Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          padding: "1rem",
          display: "flex",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <button
          onClick={onBack}
          style={{
            background: "none",
            border: "none",
            color: "#fff",
            fontSize: "1.5rem",
            cursor: "pointer",
          }}
        >
          ←
        </button>
        <h2 style={{ margin: 0 }}>Pending Chat Requests</h2>
      </div>

      {/* Chat Request Filter */}
      <div style={{ padding: "1rem 1.5rem", borderBottom: "1px solid #222" }}>
        <label style={{ display: "block", fontSize: "1rem", fontWeight: "bold", marginBottom: "0.25rem" }}>
          Chat Request Filter
        </label>
        <p style={{ marginTop: 0, marginBottom: "0.75rem", color: "#aaa", fontSize: "0.9rem" }}>
          Only show requests that meet your selected threshold to reduce spam.
        </p>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <input
            type="range"
            min="0.005"
            max="0.05"
            step="0.001"
            value={threshold}
            onChange={(e) => setThreshold(parseFloat(e.target.value))}
            style={{ flex: 1 }}
          />
          <span style={{ color: "#ccc", fontSize: "0.9rem", whiteSpace: "nowrap" }}>
            {threshold.toFixed(3)} SOL
          </span>
        </div>
      </div>

      {/* Handshake List */}
      <div style={{ flex: 1, overflowY: "auto", padding: "1.5rem" }}>
        {filteredPending.length === 0 ? (
          <p style={{ color: "#888", textAlign: "center" }}>
            No requests meet the current threshold.
          </p>
        ) : (
          filteredPending.map((p) => {
            const encodedKey = bs58.encode(p.viewKey);
            return (
              <div
                key={encodedKey}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "1rem",
                  backgroundColor: "#111",
                  border: "1px solid #333",
                  borderRadius: "8px",
                  padding: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <img
                  src="/images/avatar.png"
                  alt="avatar"
                  width="48"
                  height="48"
                  style={{
                    borderRadius: "24px",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />

                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "bold", fontSize: "1.1rem", marginBottom: "0.25rem" }}>
                    {encodedKey.slice(0, 10)}...
                  </div>
                  {p.message && (
                    <div style={{ fontSize: "0.9rem", color: "#ccc", marginBottom: "0.5rem" }}>
                      <em>“{p.message}”</em>
                    </div>
                  )}

                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <button
                      onClick={() => handleApprove(p.viewKey)}
                      style={{
                        backgroundColor: "#4e8cff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        padding: "0.5rem 1.25rem",
                        fontSize: "0.95rem",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      Accept Chat Request
                    </button>

                    <button
                      onClick={() => handleReject(p.viewKey)}
                      style={{
                        backgroundColor: "#333",
                        color: "#ccc",
                        border: "1px solid #555",
                        borderRadius: "6px",
                        padding: "0.5rem 1.25rem",
                        fontSize: "0.95rem",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}